module.exports = __webpack_public_path__ + "static/media/r_dot_10.16429fa4.png";